<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>东进公司参加南城街道校园食品安全管理工作会议</h2>
        <div id="meta_content">
          <span class="rich_a">
            毕磊
          </span>
          <span class="rich_b">
            东进防控
          </span>
          <span id="rich_c">
            <span>2024-02-28 14:56</span>
            广东
          </span>
        </div>
        <p>
          安全是生命之源，卫生是健康之本。为切实抓好校园食品安全管理，保障校园师生的身体健康，2月28日上午，南城街道教育管理中心、南城市场监督管理分局在南城阳光第九小学，组织举办南城街道校园食品安全管理工作会议，南城街道教育管理中心易湘荣副主任、南城市场监督管理分局徐晓明副局长出席会议，南城街道近90所中小学、幼儿园有关负责人参加会议。
        </p>
        <img
          width="100%"
          :src="img[0]"
          alt=""
        >
        <p>
          东进公司受邀在会议上进行了一场学校食品安全—“绿色”病媒生物防制专题讲座，并特意邀请了国内病媒生物防控行业专家、原海南省疾病预防控制中心主任技师赵伟教授详细分享了如何预防和控制病媒生物的传播经验，助力南城街道各所教育机构切实做好病媒生物防控，保障校园食品安全。
        </p>
        <img
          width="100%"
          :src="img[1]"
          alt=""
        >
        <p>
          “鼠头鸭脖事件”不仅仅只是一起单纯的食品安全事件，更是对整个校园病媒生物防控情况的一次警醒和反思，暴露出全社会对病媒生物防控意识的缺乏”。
        </p>
        <img
          :src="img[2]"
          alt=""
        >
        <p>
          会上，东进公司总经理王伟向参会人员阐述了校园加强病媒生物防控的重要性和迫切性，他指出，病媒生物防控不仅仅是企业的责任，更是全社会的责任，东进公司作为当前全国唯一一家病媒生物防控的市属国企，将义不容辞承担起应有的社会责任，主动帮助校园排查校内病媒生物防控整体状况，并提供一系列的防控措施和建议，协助学校尽快建立健全病媒生物防控体系，为建设安全健康的校园环境作出应有贡献。
        </p>
        <img
          :src="img[3]"
          alt=""
        >
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News10' })"
          >东进公司受邀参加黄江镇校园...&nbsp;&nbsp;&nbsp;&nbsp;上一条 &gt;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News8' })"
          >东进公司开展消防技能培训活动...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>

      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news9-1.png'), require('@/assets/news9-2.png'), require('@/assets/news9-3.png'), require('@/assets/news9-4.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 10px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

img {
  width: 100%;
  height: auto !important;
  visibility: visible !important;
}

#meta_content {
  font-size: 15px;
  padding-left: 2em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
